import { Link } from 'react-router-dom';

export function BuildingsFooter() {
  return (
    <footer className="bg-[#505A5A] text-white rounded-t-2xl">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-1">
            <Link to="/" className="cursor-pointer">
              <img
                src="https://static.readdy.ai/image/55893c4a5915be14917a0a81b6ec721d/a4b8636c33e8146dfbc3ea0de5e3dfdc.png"
                alt="Compliant Rental Management Logo"
                className="h-20 w-auto mb-4 brightness-0 invert"
              />
            </Link>
            <p className="text-base text-gray-300 leading-relaxed">
              Compliant furnished rental and short-stay management across Metro Vancouver
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/buildings-that-allow-str"
                  className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  STR Buildings Map
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Compliance Review
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Short-Term Co-Hosting
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Medium-Term Rentals
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Listing Setup
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-3">Have a question?</h4>
            <p className="text-sm text-gray-300 mb-4">
              Reach out anytime. We&apos;re here to help you understand your options.
            </p>
            <a
              href="mailto:contact@furnishedrentalmanagement.com"
              className="inline-block border-2 border-[#882629] text-[#882629] bg-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#882629] hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              Contact Us
            </a>
          </div>
        </div>

        <div className="border-t border-gray-400 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-300">
              © 2025 Compliant Rental Management. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-sm text-gray-300 hover:text-white transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
